// Footer.jsx
export default function Footer() {
  return (
    <footer className="text-white text-center p-4 text-sm" style={{ backgroundColor: "#8C1313" }}>
      © 2025 Vishwasari Industries. All Rights Reserved.
    </footer>
  );
}